"use client";

import Link from "@components/Link";
import type { Maybe, NavigationLink } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

export default function HeroCategories({
  sublinksCollectionItems,
  currentPath,
  locale,
  classNames,
}: {
  sublinksCollectionItems?: Maybe<NavigationLink>[];
  currentPath?: Maybe<string>;
  locale?: string;
  classNames?: { wrapper?: string; link?: string };
}) {
  if (!sublinksCollectionItems?.length) return null;

  return (
    <div
      className={cn(
        "mt-4 flex max-w-4xl gap-2 overflow-x-auto md:mt-3 md:flex-wrap",
        classNames?.wrapper,
      )}
    >
      {sublinksCollectionItems?.filter(Boolean).map((subcategory) => (
        <Link
          key={subcategory?.sys.id}
          locale={locale}
          href={subcategory?.internalLink?.slug}
          className={cn(
            "btn-outlined flex h-8 items-center justify-center whitespace-nowrap px-2 focus:border-black focus:bg-black focus:text-white focus:outline-none",
            currentPath === subcategory?.internalLink?.slug &&
              "border-black bg-black text-white",
            classNames?.link,
          )}
        >
          {subcategory?.title}
        </Link>
      ))}
    </div>
  );
}
